<ox-alert  
  [boldMessage]="false" 
  [margin]="'mb-5'"
  [whiteBackground]="true" 
  [type]="type" 
  role="alert">
  <div>{{message}} 
    <a
      (keyup.enter)="handleButton.emit($event)" 
      (click)="handleButton.emit($event)" 
      tabindex="0" 
      class="mt-3 gb-body1 heavy">
      {{linkOrButtonText}}
    </a>
  </div>
</ox-alert>
